import axiosInstance from "@/api/axios-instance";

export interface RemoveProductsResult {
  deleted: number;
  deactivated: number;
}

// Remove one product's offerings + config from a region.
export async function removeRegionProduct(
  regionId: string,
  productId: string,
): Promise<RemoveProductsResult> {
  return (
    await axiosInstance.delete(`/region/${regionId}/products/${productId}`)
  ).data;
}

// Remove all products from a region.
export async function removeAllRegionProducts(
  regionId: string,
): Promise<RemoveProductsResult> {
  return (await axiosInstance.delete(`/region/${regionId}/products`)).data;
}
